
exports.PieChart = require('./PieChart');



//////////////////
// WEBPACK FOOTER
// ./~/react-d3/piechart/index.js
// module id = 359
// module chunks = 0